import { render, staticRenderFns } from "./_overview.vue?vue&type=template&id=1f15c21f&lang=pug&"
import script from "./_overview.vue?vue&type=script&lang=js&"
export * from "./_overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports